import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import Button from '../Button';

function ToolbarAction(_ref) {
  var secondary = _ref.secondary,
      restProps = _objectWithoutPropertiesLoose(_ref, ["secondary"]);

  return /*#__PURE__*/React.createElement(Button, _extends({
    size: "xs",
    theme: "primary",
    variant: secondary ? 'naked' : 'outline'
  }, restProps));
}

export default ToolbarAction;